/* eslint-disable max-len */
import React, { useState } from 'react';
import { Dialogs, Dialog, TextInput, Toast, Label, Pane } from '@leverege/ui-elements';
import { UserSettings } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const VERSION_EX = /[a-zA-Z0-9_-]/;
const {
  t,
  tf,
  tfArray,
  tIcon,
  tfIcon
} = I18N.ns('molten.views.userSettings.SaveAsNewVersion');
function acceptVersionKey(e) {
  return VERSION_EX.test(e.key);
}
function SaveNewDialog(props) {
  const {
    show,
    onClose,
    onSave
  } = props;
  const [newVersionName, onVChange] = useState('');
  const onNewVersionNameChange = ({
    value
  }) => onVChange(value);
  const onOkay = evt => {
    onClose(evt);
    onSave({
      value: newVersionName,
      original: evt
    });
  };
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    title: t('title'),
    onCancel: onClose,
    onOkay: onOkay,
    children: /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colM",
      children: [/*#__PURE__*/_jsx(Label, {
        id: "newVersionName",
        children: t('newVersionName')
      }), /*#__PURE__*/_jsx(TextInput, {
        id: "newVersionName",
        acceptKey: acceptVersionKey,
        value: newVersionName,
        onChange: onNewVersionNameChange
      })]
    })
  });
}
export default {
  id: 'molten.userSetting.titleRight.saveTo.newVersion',
  name: tf('name'),
  matches: {
    use: 'titleRight',
    client: ['UserSettingsEditor', 'ExportSettingsEditor']
  },
  handles: context => {
    return !context.simple;
  },
  layout: {
    group: ['saveTo'],
    groupIcons: [tfIcon('icon', 'fa fa-upload fa-fw')],
    groupNames: tfArray('groupNames'),
    sort: 'zzzz'
  },
  appearance: ({
    context,
    action
  }) => {
    return {
      name: t('appearanceName'),
      icon: tIcon('addIcon', 'fa fa-plus fa-fw')
    };
  },
  perform: ({
    context,
    onClose: closeParent
  }) => {
    const {
      value,
      versionsPath,
      onClose,
      clientProps
    } = context;
    const actionCloseOnExec = clientProps?.actionCloseOnExec;
    const onSave = async evt => {
      try {
        await UserSettings.setVersion(versionsPath, evt.value, value);
        Toast.success([t('successToastTitle'), t('successToastMessage', {
          data: evt.value
        })]);
      } catch (err) {
        Toast.error([t('errorToastTitle'), t('errorToastMessage1', {
          data: evt.value
        }), t('errorToastMessage2', {
          error: err.message
        })`Reason: ${err.message}`]);
      }
      if (onClose && actionCloseOnExec) onClose(evt);
    };
    if (closeParent) closeParent();
    Dialogs.show({
      component: SaveNewDialog,
      props: {
        onSave
      }
    });
  }
};